import { BASE_URL } from '../API/BASE_URL';

export const getChiefs = async () => {
  const response = await fetch(BASE_URL + 'welcome_words/welcome_words/', {
    method: 'GET',
  });

  const data = await response.json();

  return data;
};
